import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonListItem,
} from '@/components/common/skeleton';

const ATTENDEE_COUNT = 6;

export const EventAttendanceTabSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <View style={styles.statsRow}>
      <SkeletonCard padding={12} style={styles.statCard}>
        <SkeletonBone width={60} height={11} />
        <SkeletonBone width={80} height={22} />
      </SkeletonCard>
      <SkeletonCard padding={12} style={styles.statCard}>
        <SkeletonBone width={60} height={11} />
        <SkeletonBone width={80} height={22} />
      </SkeletonCard>
    </View>
    <View style={styles.controlsRow}>
      <View style={styles.searchWrap}>
        <SkeletonBone width="100%" height={40} borderRadius={8} />
      </View>
      <SkeletonBone width={60} height={40} borderRadius={8} />
    </View>
    <View style={styles.list}>
      {Array.from({ length: ATTENDEE_COUNT }).map((_, i) => (
        <SkeletonListItem
          key={i}
          avatar
          avatarSize={32}
          lines={2}
          lineWidths={['60%', '40%']}
        />
      ))}
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 16,
    gap: 16,
  },
  statsRow: {
    flexDirection: 'row',
    gap: 12,
  },
  statCard: {
    flex: 1,
  },
  controlsRow: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
  },
  searchWrap: {
    flex: 1,
  },
  list: {
    gap: 12,
  },
});
